<div class="header-sort" (click)="onClickDirection()">
  <span>{{ description }}</span>
  <em *ngIf="direction === 'asc'" class="fa fa-arrow-down"></em>
  <em *ngIf="direction === 'desc'" class="fa fa-arrow-up"></em>
</div>
